import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Work from "@/pages/Work";
import Clients from "@/pages/Clients";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#141414",
              color: "#FAF8F3",
              border: "1px solid rgba(139,115,85,0.4)",
              fontFamily: "Inter, sans-serif",
              borderRadius: "4px",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout overHero><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/work" element={<Layout><Work /></Layout>} />
          <Route path="/clients" element={<Layout><Clients /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
        </Routes>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
